export default function HappyNewYear() {
  return (
    <div>
      <h1>Toivottaa Hyvää Uutta Vuotta!</h1>
    </div>
  );
}
